<template>
    <div
        :class="paymentProceedFormClassList"
        class="o-payment-proceed-form payment-proceed-form"
        at-o-payment-proceed-form
    >
        <template v-if="!isEmbedded">
            <iframe
                v-if="isSrcDoc"
                :srcdoc="srcDoc"
                class="payment-proceed-form__iframe"
                frameborder="0"
            />
            <iframe
                v-else
                :src="src"
                class="payment-proceed-form__iframe"
                frameborder="0"
            />
        </template>
        <MLoader v-else />
    </div>
</template>

<script>
import MLoader from '../../molecules/m-loader';

import EventBus from '../../../utils/event-bus';
import { escapeHtml } from '../../../utils/services/app-service';
import { CONFIG } from '../../../utils/services/global-config-service';
import {
    APPEND_EXTERNAL_HTML,
    REMOVE_EXTERNAL_HTML
} from '../../../utils/constants/event-constants';
import { CARD_STATUS } from '../../../utils/constants/status-constants';

const FORM_METHODS = {
    POST: 'POST',
    GET: 'GET'
};

const IFRAME_3DS_ID = '3dsIframe';

export default {
    name: 'OPaymentProceedForm',
    props: {
        /**
         * Set data for payment proceed form
         * @property action { String }
         * @property method { String }
         * @property params { Object }
         */
        paymentProceedFormData: {
            type: Object,
            default: () => ({})
        },
        /**
         * Set Token
         */
        token: {
            type: String,
            default: ''
        },
        /**
         * Set status
         */
        status: {
            type: String,
            default: ''
        }
    },
    components: {
        MLoader
    },
    data() {
        return {
            isEmbedded: CONFIG.IS_EMBEDDED
        }
    },
    computed: {
        srcDoc() {
            const inputs = Object.entries(this.paymentProceedFormData.params).map(([key, value]) => {
                return `<input type="hidden" name="${key}" value="${value}" />`
            });
            const form = `
                <form id="paymentProceedForm" method="${this.paymentProceedFormData.method}" action="${this.paymentProceedFormData.action}">
                    ${inputs.join('')}
                </form>
            `;
            return `<body onload="document.forms['paymentProceedForm'].submit();">${form}</body>`;
        },
        src() {
            return this.paymentProceedFormData.action;
        },
        isSrcDoc() {
            return this.paymentProceedFormData.method === FORM_METHODS.POST;
        },
        paymentProceedFormClassList() {
            // do not delete this className 'payment-proceed-form--relative'
            // it can be helpfully in future changes
            return 'payment-proceed-form--fixed';
        },
        htmlIframe3ds() {
            const styleString = `
                position: fixed;
                top: 0;
                left: 0;
                z-index: 100;
                width: 100%;
                height: 100%;
            `;
            const srcString = this.isSrcDoc ? `srcdoc="${escapeHtml(this.srcDoc)}"` : `src="${this.src}"`;
            return `<iframe style="${styleString}" frameborder="0" ${srcString}></iframe>`;
        }
    },
    watch: {
        status: {
            handler(status) {
                if ([CARD_STATUS.SUCCESS, CARD_STATUS.FAIL].includes(status)) {
                    this.emitRemovePublisher();
                }
            }
        }
    },
    mounted() {
        this.initListeners();
        this.emitPublisher();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    methods: {
        emitRemovePublisher() {
            if (this.isEmbedded) {
                EventBus.$emit(REMOVE_EXTERNAL_HTML, IFRAME_3DS_ID);
            }
        },
        emitPublisher() {
            if (this.isEmbedded) {
                const config = {
                    id: IFRAME_3DS_ID,
                    html: this.htmlIframe3ds
                }
                EventBus.$emit(APPEND_EXTERNAL_HTML, config);
            }
        },
        initListeners() {
            window.addEventListener('changeIframeState', this.handleIframeStateEvent);
        },
        removeListeners() {
            window.removeEventListener('changeIframeState', this.handleIframeStateEvent);
        },
        handleIframeStateEvent() {
            this.$emit('changeIframeState');
        }
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
